<template>

    <div>

    </div>
</template>


<script>
export default {
    created() {
        localStorage.clear()
        this.$router.replace('/ssoLogin')
    }
}

</script>